
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/associations/[associationId]/analytics/big-spenders",
      function () {
        return require("private-next-pages/associations/[associationId]/analytics/big-spenders.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/associations/[associationId]/analytics/big-spenders"])
      });
    }
  